import React from "react";
import AgentLayout from "../../../agentComponents/AgentLayout";
import TicketTable from "./table";

const AgentTickets = () => (
  <AgentLayout title="Tickets" subtitle="Everything raised from the floor, newest first.">
    <TicketTable />
  </AgentLayout>
);

export default AgentTickets;
